import React from 'react';
import { ChevronRight } from 'lucide-react';

interface WelcomeProps {
  onStart: () => void;
}

export default function Welcome({ onStart }: WelcomeProps) {
  return (
    <div className="text-center">
      {/* Main Heading */}
      <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 text-left">
        Operational Overwhelm Draining Your Ministry Energy?
      </h1>

      {/* Description */}
      <p className="text-lg text-gray-600 mb-8 text-left">
        You were called to lead, preach, shepherd, and serve. Yet, the daily reality often involves coordinating people, wrestling with budgets, crafting communications, managing facilities, navigating technology, and trying to keep administrative systems afloat.
      </p>

      <p className="text-lg text-gray-600 mb-8 text-left">
        <i>But what if you could identify the specific areas holding you back?</i>
      </p>

      {/* Assessment List */}
      <div className="space-y-4 text-left mb-8">
        <p className="text-lg text-gray-700">
          Take the first step towards greater clarity, reduced stress, and more time dedicated to your core ministry. Click the button below to get your Church Ops Score!
        </p>
      </div>

      {/* Button */}
      <button
        onClick={onStart}
        className="inline-flex items-center px-6 py-3 bg-[#163B56] text-white font-medium rounded-lg hover:bg-[#0D2436] focus:outline-none focus:ring-2 focus:ring-[#163B56] transition-colors"
        aria-label="Start the assessment"
      >
        Get Your Church Ops Score
        <ChevronRight className="ml-2 w-5 h-5" />
      </button>
    </div>
  );
}
